import { render, staticRenderFns } from "./create_menu.vue.js?vue&type=template&id=5d4f5f78!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=template&id=5d4f5f78"
import script from "./create_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js"
export * from "./create_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports